import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/secondRow.css";
import logo from "./assets/MBS-Logo-header.png";

function SecondRow() {
  // const [openSubmenu, setOpenSubmenu] = useState(null);

  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [lockedSubmenu, setLockedSubmenu] = useState(null);

  // const toggleSubmenu = (menu) => {
  //   setOpenSubmenu(openSubmenu === menu ? null : menu);
  // };

  const toggleSubmenu = (menu) => {
    if (lockedSubmenu === menu) {
      setLockedSubmenu(null);
      setOpenSubmenu(null);
    } else {
      setLockedSubmenu(menu);
      setOpenSubmenu(menu);
    }
  };

  React.useEffect(() => {
    const closeOnOutsideClick = (e) => {
      if (!e.target.closest(".navbar")) {
        setLockedSubmenu(null);
        setOpenSubmenu(null);
      }
    };

    document.addEventListener("click", closeOnOutsideClick);
    return () => document.removeEventListener("click", closeOnOutsideClick);
  }, []);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light second-row bottom-shadow sticky-top">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="MBS Logo" className="navbar-logo" />
        </Link>

        {/* Mobile toggler */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <NavLink to="/" label="Home" />

            <Dropdown title="Who We Are">
              <DropdownItem to="/about" label="About Us" />
              <DropdownItem to="/mbsmanagement" label="MBS Management" />
              <DropdownItem to="/mbsstrategicplan" label="MBS Strategic Plan" />
              <DropdownItem
                to="/responsibility"
                label="Corporate Social Responsibility"
              />
              <DropdownItem
                to="/offices_and_staffing"
                label="Offices and Staffing"
              />
            </Dropdown>

            <Dropdown title="What We Do">
              <Submenu
                title="Standards Development"
                menuKey="standards"
                openSubmenu={openSubmenu}
                toggleSubmenu={toggleSubmenu}
              >
                <DropdownItem to="/overview" label="Overview" />
                <DropdownItem
                  to="/DevelopmentofMalawiStandards"
                  label="Development of Malawi Standards"
                />
                <DropdownItem
                  to="/technicalCommittees"
                  label="Technical Committees"
                />
                <DropdownItem
                  to="/standardsCatalogue"
                  label="Published Malawi Standards"
                />
                <DropdownItem
                  to="/StandardsUnderPublicReview"
                  label="Standards Under Public Review"
                />
                <DropdownItem
                  to="/SACListOfApprovedStandards"
                  label="National Standardization Strategy"
                />
                <DropdownItem
                  to="/SACListOfApprovedStandards"
                  label="Standards Work Programme"
                />
                <DropdownItem
                  to="/standards_information_centre"
                  label="Standards Information Centre"
                />
                <DropdownItem
                  to="/MBSSICmembershischeme"
                  label="MBS-SIC Membership Scheme"
                />
                <DropdownItem
                  to="/CatalogueOfMalawiStandards"
                  label="Catalogue of Malawi Standards"
                />
                <DropdownItem
                  to="/WTOTBTSPSNationalEnquiryPoint"
                  label="WTO-TBT/SPS National Enquiry Point"
                />
                <DropdownItem
                  to="/SACListOfApprovedStandards"
                  label="National Codex Committee"
                />
                <DropdownItem
                  to="/SACListOfApprovedStandards"
                  label="National Electrotechnical Committee"
                />
              </Submenu>

              <Submenu
                title="Inspection & Certification"
                menuKey="inspection"
                openSubmenu={openSubmenu}
                toggleSubmenu={toggleSubmenu}
              >
                <DropdownItem to="/overviewIandC" label="Overview" />
                <DropdownItem to="/permit_scheme" label="Permit Scheme" />
                <DropdownItem
                  to="/designation_scheme"
                  label="Designation Scheme"
                />
                <DropdownItem
                  to="/Imports_Quality_Monitoring_Scheme"
                  label="Imports Quality Monitoring Scheme"
                />
                <DropdownItem
                  to="/Imports_Quality_Monitoring_Scheme"
                  label="Exports Quality Monitoring Scheme"
                />
                <DropdownItem
                  to="/Management_Systems_Certification_Scheme"
                  label="Management Systems Certification Scheme"
                />
                <DropdownItem
                  to="/consumer_complaints_handling"
                  label="Consumer Complaints Handling"
                />
              </Submenu>

              <Submenu
                title="Testing Services"
                menuKey="testing"
                openSubmenu={openSubmenu}
                toggleSubmenu={toggleSubmenu}
              >
                <DropdownItem to="/TestingServices" label="Overview" />
                <DropdownItem
                  to="/TestingLaboratories"
                  label="Testing Laboratories"
                />
                <DropdownItem
                  to="/testingOtherServices"
                  label="Other Services"
                />
              </Submenu>
              <Submenu
                title="Metrology Services"
                menuKey="metrology"
                openSubmenu={openSubmenu}
                toggleSubmenu={toggleSubmenu}
              >
                <DropdownItem to="/MetrologyServices" label="About Metrology" />
                <DropdownItem
                  to="/QualityManagement"
                  label="Verification and Inspection Services"
                />
                <DropdownItem
                  to="/MetrologyTraining"
                  label="Calibration Services"
                />
              </Submenu>
              <Submenu
                title="Training"
                menuKey="training"
                openSubmenu={openSubmenu}
                toggleSubmenu={toggleSubmenu}
              >
                <DropdownItem
                  to="/national_quality_institute"
                  label="Overview"
                />
                <DropdownItem
                  to="/AccreditationCertification"
                  label="Consultancies"
                />
                <DropdownItem to="/NQITrainingCalendar" label="Training" />
              </Submenu>
            </Dropdown>

            <Dropdown title="Customer Care">
              <DropdownItem to="/customerService" label="Service Charter" />
              <DropdownItem
                to="/complaintsHandling"
                label="Consumer Complaints Handling"
              />
            </Dropdown>
            <Dropdown title="Online Services">
              <DropdownItem
                to="https://www.mis-mbsmw.org/"
                label="MBS Management Information System (MIS)"
              />
              <DropdownItem
                to="/standardsCatalogue"
                label="Purchase Malawi Standards"
              />
              <DropdownItem
                to="https://mbs.isolutions.iso.org/mbs"
                label="Purchase ISO Standards"
              />
              <DropdownItem
                to="http://192.168.24.123:5810/login"
               /* label="Certification Mark Fee Structure"*/
              />
              <DropdownItem
                to="http://192.168.0.5:3003/"
                label="MBS E-learning"
              />
              <DropdownItem
                to="http://192.168.0.5:7006/login"
                label="Submit Queries"
              />
            </Dropdown>
            <NavLink to="/mediaPublications" label="Media Publications" />
            <Dropdown title="Access To Information">
              <DropdownItem
                to="/informationOfficers"
                label="Information Officers"
              />
              <DropdownItem
                to="/accessToInformationForms"
                label="Access To Information Forms"
              />
              <DropdownItem
                to="/accessToInformationManual"
                label="Access To Information Manual"
              />
              <DropdownItem to="/legislationDocuments" label="Legislation" />
              <DropdownItem to="/otherDocuments" label="Other Documents" />
            </Dropdown>

            <NavLink to="/contactUs" label="Contact Us" />
          </ul>
        </div>
      </div>
    </nav>
  );
}

/* ---------- Reusable Components ---------- */

const NavLink = ({ to, label }) => (
  <li className="nav-item">
    <Link className="nav-link" to={to}>
      {label}
    </Link>
  </li>
);

const Dropdown = ({ title, children }) => (
  <li className="nav-item dropdown">
    <button
      className="nav-link dropdown-toggle btn btn-link"
      data-bs-toggle="dropdown"
      type="button"
    >
      {title}
    </button>
    <ul className="dropdown-menu">{children}</ul>
  </li>
);

const Submenu = ({
  title,
  menuKey,
  openSubmenu,
  lockedSubmenu,
  setOpenSubmenu,
  toggleSubmenu,
  children,
}) => (
  <li
    className="dropdown-submenu"
    onMouseEnter={() => {
      if (!lockedSubmenu && window.innerWidth >= 992) {
        setOpenSubmenu(menuKey);
      }
    }}
    onMouseLeave={() => {
      if (!lockedSubmenu && window.innerWidth >= 992) {
        setOpenSubmenu(null);
      }
    }}
  >
    <button
      className="dropdown-item dropdown-toggle submenu-toggle"
      type="button"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleSubmenu(menuKey);
      }}
    >
      {title}
    </button>

    <ul className={`dropdown-menu ${openSubmenu === menuKey ? "show" : ""}`}>
      {children}
    </ul>
  </li>
);

const DropdownItem = ({ to, label }) => (
  <li>
    <Link className="dropdown-item" to={to}>
      {label}
    </Link>
  </li>
);

export default SecondRow;
